let http
if (process.env.NODE_ENV === 'development') {
  http = '/static'
} else {
  http = process.env.VUE_APP_BASE_API
}
export default { http }
